import React, { useState } from 'react';
import jMoment from 'moment-jalaali';
import {
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { DatetimePickerTrigger } from 'imrc-datetime-picker';
import "imrc-datetime-picker/dist/imrc-datetime-picker.css";

import { enDigits } from "../../utils/formatDigits";

import "./DatePicker.scss";

export default props => {
  const { input, label, id, meta = {}, ...rest } = props;
  const [moment, setMoment] = useState(input.value ? jMoment(enDigits(input.value), 'jYYYY/jM/jD') : jMoment())
  jMoment.locale();
  return (
    <FormGroup>
      {label && <Label htmlFor={id}>{label}</Label>}
      <DatetimePickerTrigger
        moment={moment}
        showTimePicker={false}
        isSolar
        lang={"fa"}
        {...props}
        onChange={e => {
          setMoment(e);
          input.onChange(jMoment(e).format('jYYYY-jM-jD'));
        }}
        closeOnSelectDay
        className="datepicker"
      >
        <Input id={id} {...input} {...rest} invalid={meta.error && meta.touched} readOnly />
        {meta.error && meta.touched && <FormFeedback>{meta.error}</FormFeedback>}
      </DatetimePickerTrigger>
    </FormGroup>
  )
}